import { Injectable } from '@angular/core'
import { Logger } from '../../logger.service'
import * as Excel from 'exceljs/dist/exceljs.min.js'
import * as fs from 'file-saver'
const log = new Logger('GuestExportDatabaseService')
import * as _moment from 'moment'
import { HMPGlobal } from '@hmp/config/HMPGlobal'
import { AuthService } from '../general/auth.service'
const moment = _moment
declare const ExcelJS: any
@Injectable({ providedIn: 'root' })
export class RollingForeCastExportService {
  constructor(
    private auth: AuthService
  ) {}

  private getCurrencyInfo() {
    const currency = this.auth.getCurrentCurrency()
    return HMPGlobal.getCurrency(currency)
  }
  
  onGenerateReportExcel(
    title, 
    data: any[],
    businessName,
    sheetname,
    filename,
  ) {
    const headerRow1Columns = [
      '',
      '',
      '',
      'BUDGET',
      'ACTUALS TO DATE',
      '',
      'EST. FOR COMPLETION',
      '',
      'FORECAST TOTAL COST',
      '',
      'B2A VARIANCE',
      ''
    ]
    const headerRow2Columns = [
        '',
        '',
        'ROLLING FORECAST SUMMARY',
        `${this.getCurrencyInfo().name}`,
        `${this.getCurrencyInfo().name}`,
        'BGT %',
        `${this.getCurrencyInfo().name}`,
        'BGT % ',
        `${this.getCurrencyInfo().name}`,
        'BGT %',
        `${this.getCurrencyInfo().name}`,
        'VAR %'
      ]

    let workbook = new Excel.Workbook()
    workbook.creator = 'HMP'
    workbook.lastModifiedBy = 'HMP'
    workbook.created = new Date()
    workbook.modified = new Date()
    workbook.lastPrinted = new Date()

    let worksheet = workbook.addWorksheet(sheetname, {
      properties: {
        tabColor: { argb: 'FFFFFF00' },
        showGridLines: false,
        defaultRowHeight: 20,
      },
      views: [{ state: 'normal', showGridLines: false }],
    })


    // COLUMN WIDTH
    worksheet.columns = [
      { key: 'A5', width: 10 },
      { key: 'B5', width: 10 },
      { key: 'C5', width: 25 },
      { key: 'D5', width: 15 },
      { key: 'E5', width: 15 },
      { key: 'F5', width: 15 },
      { key: 'G5', width: 15 },
      { key: 'H5', width: 15 },
      { key: 'I5', width: 15 },
      { key: 'J5', width: 15 },
      { key: 'K5', width: 15 },
      { key: 'L5', width: 15 },
    ]

    // TITLE ROW 0,1,2
    worksheet.mergeCells('B2', 'L2');
    let titleRow = worksheet.getCell('B2');
    titleRow.value = title
    titleRow.font = {
      name: 'Calibri',
      size: 14,
      bold: true,
      color: { argb: '000000' }
    }
    titleRow.alignment = { vertical: 'middle', horizontal: 'center' }
    
    let date = worksheet.getCell('B3');
    const now = new Date()
    const dateNow = moment(now)
    date.value = moment(dateNow).format("DD-MMM-YYYY, HH:mm A")
    date.font = {
      name: 'Calibri',
      size: 10,
      italic: true,
      bold: false,
      color: { argb: '000000' }
    }
    date.alignment = { vertical: 'middle', horizontal: 'left' }

    let name = worksheet.getCell('B4');
    name.value = 'Component Summary'
    name.font = {
      name: 'Calibri',
      size: 14,
      bold: true,
      color: { argb: '000000' }
    }
    
    name.alignment = { vertical: 'middle', horizontal: 'left' }
    let namedemo = worksheet.getCell('G4');
    namedemo.value = businessName
    namedemo.font = {
      name: 'Calibri',
      size: 14,
      bold: true,
      color: { argb: '000000' }
    }
    namedemo.alignment = { vertical: 'middle', horizontal: 'right' }
    worksheet.mergeCells('B4', 'F4');
    worksheet.mergeCells('G4', 'L4');
    let headerRow1 = worksheet.addRow(headerRow1Columns)
    headerRow1.font = {
      name: 'Calibri',
      size: 10,
      bold: true,
    }
    headerRow1.eachCell((cell, number) => {
      if (number > 1) {
        cell.border = {
          top: { style: 'medium' },
          bottom: { style: 'thin' },
          right: {style:'thin', color: {argb:'F3F4F3'}}
        }
        cell.alignment = { horizontal: 'right', vertical: 'middle' }
      }
    })
    headerRow1.height = 20
    
    worksheet.mergeCells('E5', 'F5');
    worksheet.mergeCells('G5', 'H5');
    worksheet.mergeCells('I5', 'J5');
    worksheet.mergeCells('K5', 'L5');

    let headerRow2 = worksheet.addRow(headerRow2Columns)
    headerRow2.font = {
      name: 'Calibri',
      size: 10,
      bold: true,
    }
    headerRow2.eachCell((cell, number) => {
      if (number > 1) {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
              argb: 'F3F4F3',
            },
            bgColor: {
              argb: 'F3F4F3',
            },
        },
        cell.border = {
            right: {style:'thin', color: {argb:'ffffff'}}
        }
        cell.alignment = { horizontal: 'right', vertical: 'middle' }
      }
    })
    worksheet.getCell('B6').alignment = { horizontal: 'left', vertical: 'middle'  }
    // headerRow2.height = 20
    for (let index = 0; index < data.length; index++) {
      const r = data[index]
      let dataRowColumn = this.generateProductionReportColumnArr(r)
      let dataRow = worksheet.addRow(dataRowColumn)
      
      
      dataRow.font = {
        name: 'Calibri',
        size: 10,
        bold: false,
      }
    //   dataRow.border = {
    //     right: {style:'thin', color: {argb:'E0E0E0'}}
    //   }
      dataRow.alignment = { horizontal: 'left', vertical: 'middle' }
      dataRow.getCell('B').alignment = { horizontal: 'left' }
      dataRow.getCell('C').alignment = { horizontal: 'left' }
      dataRow.getCell('D').alignment = { horizontal: 'right' }
      dataRow.getCell('E').alignment = { horizontal: 'right' }
      dataRow.getCell('F').alignment = { horizontal: 'right' }
      dataRow.getCell('G').alignment = { horizontal: 'right' }
      dataRow.getCell('H').alignment = { horizontal: 'right' }
      dataRow.getCell('I').alignment = { horizontal: 'right' }
      dataRow.getCell('J').alignment = { horizontal: 'right' }
      dataRow.getCell('K').alignment = { horizontal: 'right' }
      dataRow.getCell('L').alignment = { horizontal: 'right' }

      
      dataRow.getCell('C').border = { right: {style:'thin', color: {argb:'E0E0E0'}} }
      dataRow.getCell('D').border = { right: {style:'thin', color: {argb:'E0E0E0'}} }
      dataRow.getCell('E').border = { right: {style:'thin', color: {argb:'E0E0E0'}} }
      dataRow.getCell('F').border = { right: {style:'thin', color: {argb:'E0E0E0'}} }
      dataRow.getCell('G').border = { right: {style:'thin', color: {argb:'E0E0E0'}} }
      dataRow.getCell('H').border = { right: {style:'thin', color: {argb:'E0E0E0'}} }
      dataRow.getCell('I').border = { right: {style:'thin', color: {argb:'E0E0E0'}} }
      dataRow.getCell('J').border = { right: {style:'thin', color: {argb:'E0E0E0'}} }
      dataRow.getCell('K').border = { right: {style:'thin', color: {argb:'E0E0E0'}} }
      dataRow.getCell('L').border = { right: {style:'thin', color: {argb:'E0E0E0'}} }
      dataRow.getCell(4).numFmt = this.getCellFormat(false)
      dataRow.getCell(5).numFmt = this.getCellFormat(false)
      dataRow.getCell(6).numFmt = this.getCellFormat(true)
      dataRow.getCell(7).numFmt = this.getCellFormat(false)
      dataRow.getCell(8).numFmt = this.getCellFormat(true)
      dataRow.getCell(9).numFmt = this.getCellFormat(false)
      dataRow.getCell(10).numFmt = this.getCellFormat(true)
      dataRow.getCell(11).numFmt = this.getCellFormat(false)
      dataRow.getCell(12).numFmt = this.getCellFormat(true)
    }
    const lastRow = worksheet.lastRow;
    lastRow.font = {
        name: 'Calibri',
        color: { argb: '428BCA' },
        size: 12,
        bold: true,
    }
    worksheet.mergeCells('B5', 'C5');
    worksheet.mergeCells('B6', 'C6');
    workbook.xlsx.writeBuffer().then(data => {
      let blob = new Blob([data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      fs.saveAs(blob, filename + '.xlsx')
    })
  }

  private generateProductionReportColumnArr(data) {
    let row = []
    let costCenter = ''
    let name
    if(data.costCenter){
      costCenter = data.costCenter 
    }
    if(data.name){
      name = data.name 
    }
    if(data.name == 'Total'){
      costCenter = 'Total'
      name = '';
    }
    row.push('')
    row.push(costCenter)
    row.push(name)
    row.push(data.budgetAmount)
    row.push(data.actualAmount)
    row.push(`${data.actualBgt.toFixed(1)}%`)
    row.push(data.estimate)
    row.push(`${data.estimateBgt.toFixed(1)}%`)
    row.push(data.forecastAmount.toFixed(1))
    row.push(`${data.forecastBgt.toFixed(1)}%`)
    row.push(data.b2fAmount)
    row.push(`${data.b2fBgt.toFixed(1)}%`)
    return row
  }

  private getCellFormat(isPercent = true) {
    if (isPercent) {
      return '0.0%'
    }
    return '#,##0.00'
  }
}
